import { DateHelper } from "../../../../Common/DateHelper";
import { ODataSelect } from "../../../../Providers.Api/ODataQuery";

export class TicketedEvent extends ODataSelect
{
    public Node_Id = 0;
    public Ticketed_Event_Id = "";
    public Booking_Id = "";
    public Event_Title = "";
    public Event_Short_Description = "";
    public Event_Description = "";
    public WebSite_URL = "";
    public ImageURI = "";
    public Event_Date = DateHelper.null();
    public Event_Start_DateTime = DateHelper.null();
    public Event_End_DateTime = DateHelper.null();
    public Event_Capacity = 0;
    public IsWaitingList_Allowed = false;
    public Invite_Permission = "";
    public Event_Status = "";
    public Space_Id = "";


    public init(response: any, nodeId: number): TicketedEvent
    {
        super.init(response, nodeId);
        this.Event_Date = DateHelper.fromIsoByNode(response.Event_Date, nodeId);
        this.Event_Start_DateTime = DateHelper.fromIsoByNode(response.Event_Start_DateTime, nodeId);
        this.Event_End_DateTime = DateHelper.fromIsoByNode(response.Event_End_DateTime, nodeId);
        this.IsWaitingList_Allowed = response.IsWaitingList_Allowed === 1 ? true : false;
        return this;
    }
}

export class BookingDetails extends ODataSelect
{
    public Booking_Id = "";
    public Booking_Party_Count = 0;
}

export class BookingParties extends ODataSelect
{
    public Booking_Participant_Status = "";
    public Booking_Participant_Type = "";
    public Booking_Id = "";
    public Node_Id = 0;
    public Booking_Participant_Email = "";
    public CreatedBy = "";
    public EventId = "";
}